import { render, staticRenderFns } from "./startupBySectorDatabase.vue?vue&type=template&id=2c9b40a2&scoped=true&"
import script from "./startupBySectorDatabase.vue?vue&type=script&lang=js&"
export * from "./startupBySectorDatabase.vue?vue&type=script&lang=js&"
import style0 from "./startupBySectorDatabase.vue?vue&type=style&index=0&id=2c9b40a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9b40a2",
  null
  
)

export default component.exports